import {useSuspenseQuery} from '@tanstack/react-query';
import {injectAlphabeticalSort, prepareSearchParams} from 'shared';

import {api} from '@/lib/ky';
import {extractPagination} from '@/utils/extractPagination';

import {checklistTemplateSchema} from '../utils/schemas/checklist';

import {checklistTemplateKeys} from './queryKeys';

import type {
  ExtractFnReturnType,
  QueryConfig,
  QueryConfig2,
} from '@/lib/react-query';

export const getChecklistTemplates = async (params: QueryParams = {}) => {
  const res = await api.get(`checklists`, {
    searchParams: prepareSearchParams(injectAlphabeticalSort(params)),
  });
  const data = await res.json();
  const pagination = extractPagination(res);

  return [checklistTemplateSchema.array().parse(data), pagination] as const;
};

export const useChecklistTemplates = (
  params?: QueryParams,
  config?: QueryConfig<QueryFnType>
) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: checklistTemplateKeys.list(params),
    queryFn: () => getChecklistTemplates(params),
  });
};
export const useChecklistTemplatesLoader = (
  config: QueryConfig2<QueryFnType>
) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>(config);
};

type QueryFnType = typeof getChecklistTemplates;
type QueryParams = Parameters<typeof checklistTemplateKeys.list>[0];
